import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo} from "react-icons/pi";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";

export default function SalesOrders() {
    const {weclappBaseUrl, user_roles, incoming_goods, col_definitions} = usePage().props;
    const [showModal, setShowModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);
    const {t} = useEnhancedTranslation();

  const openImportFor = (id) => {
    setSelectedDocumentId(id);
    setShowModal(true);
  }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/incoming-goods/${id}`, '_blank');
    }

  return (
    <>
      <InertiaTable
        key={'incominggoods-table'}
        data={incoming_goods}
        title={
          <span className="d-inline-flex align-items-center gap-2">
            Verkauf – Wareneingänge
            <HelpTooltip placement="right" size={0.95}>
              <div className="text-start">
                <strong>Welche Belege werden hier angezeigt?</strong>
                <div className="mt-1">Wareneingänge aus Weclapp nach festen Regeln:</div>
                <ul className="mb-0 ps-3 mt-1">
                  <li>Belegtyp: <strong>Wareneingang</strong> (Incoming Goods)</li>
                  <li>Status: <strong>INCOMING_SHIPPED</strong> – vom Lieferanten versandt / im Zulauf</li>
                </ul>
                <div className="mt-1">Sortierung: Datum absteigend.</div>
              </div>
            </HelpTooltip>
          </span>
        }
        actionsDisplay={'column'}
        actions={[
            { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) =>openImportFor(data.id) },
            { icon: <WeclappIcon />, alt: t('open in Weclapp'), callback: (data) =>openWeclappOrder(data.id) },

        ]}
        colDefinitions={[...col_definitions]}
        customCellRendererMap={{
            'netAmount': CurrencyTableCell,
            'createdDate':TimestampTableCell
        }}
      />
      <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'incoming_goods'} onClose={()=>setShowModal(false)} />
    </>
  );
}
